import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom'

import './App.scss'
import store from './store'
import InitialData from './components/shared/InitialData'
import {ContentStructure} from './components/shared/ContentStructure'
import MainNavbar from './components/shared/MainNavbar'
import Footer from './components/shared/Footer'
import StageIndicator from './components/shared/StageIndicator'

const RegistrationApp = () => {
  // Use the local instance if app gets used in development
  let baseUrl
  // @ts-ignore
  if (window._is_react_dev_server) {
    baseUrl = 'http://localhost:8000'
  } else {
    baseUrl = window.location.protocol + '//' + window.location.host
  }
  // Allow redirect to event details if id is given
  let event_id = ''
  const queryParams = new URLSearchParams(window.location.search)
  let participant_token = queryParams.get('token') || undefined
  const family_token = queryParams.get('family_token') ? 'family-' + queryParams.get('family_token') : undefined
  const last_pathname_entry: string =
    window.location.pathname.split('/').pop() || ''
  if (!isNaN(parseInt(last_pathname_entry))) {
    event_id = last_pathname_entry
  }

  const programId = window.location.pathname.split('/')[2]
  const isRestoredData = store.getState().misc.isRestoredData

  return (
    <Provider store={store}>
      <BrowserRouter basename={`anmeldung/${programId}`}>
        <Routes>
          <Route
            path={'/*'}
            element={
              <InitialData
                baseUrl={baseUrl}
                programId={parseInt(programId)}
                event_id={event_id}
                participant_token={participant_token}
                family_token={family_token}
                location={window.location}
                isRestoredData={isRestoredData}
              >
                <MainNavbar />
                <StageIndicator />
                <ContentStructure />
                <Footer />
              </InitialData>
            }>
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  )
}

export default RegistrationApp
